/* eslint-disable max-params */
export function lineIntersectsRect(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  minX: number,
  minY: number,
  maxX: number,
  maxY: number,
): boolean {
  // 检查线段两个端点是否在矩形内部
  if (
    pointInRect(x1, y1, minX, minY, maxX, maxY) ||
    pointInRect(x2, y2, minX, minY, maxX, maxY)
  ) {
    return true
  }

  // 检查线段与矩形的四条边是否相交
  if (
    lineIntersectsLine(x1, y1, x2, y2, minX, minY, minX, maxY) ||
    lineIntersectsLine(x1, y1, x2, y2, minX, maxY, maxX, maxY) ||
    lineIntersectsLine(x1, y1, x2, y2, maxX, maxY, maxX, minY) ||
    lineIntersectsLine(x1, y1, x2, y2, maxX, minY, minX, minY)
  ) {
    return true
  }

  return false
}

// 检查点是否在矩形内部
function pointInRect(
  x: number,
  y: number,
  minX: number,
  minY: number,
  maxX: number,
  maxY: number,
): boolean {
  return x >= minX && x <= maxX && y >= minY && y <= maxY
}

// 检测两条线段是否相交
function lineIntersectsLine(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  x3: number,
  y3: number,
  x4: number,
  y4: number,
): boolean {
  const ua =
    ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) /
    ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1))
  const ub =
    ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) /
    ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1))

  return ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1
}
